import React, { useContext } from "react";
import { ScrollRestoration } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import { AuthContext } from "../../../contexts/AuthProvider";
import Categories from "../../Categories/CategoriesInfo/CategoriesInfo";
import Banner from "../Banner/Banner";
import Gallery from "./Gallery";
import WhyChooseUs from "./WhyChooseUs";

const Home = () => {
  const { user } = useContext(AuthContext);

  return (
    <div>
      <ScrollRestoration />
      {user?.emailVerified ? (
        <></>
      ) : (
        <div
          className={
            user
              ? "bg-base-100 w-[92%] md:w-[50%] lg:w-[28%] mx-auto text-center rounded-lg px-3 py-3 mt-4 md:mt-5 shadow-xl uncommon"
              : "hidden"
          }
        >
          <span className="text-red-500 md:text-red-500 font-semibold text-[14px] md:text-[16.3px]">
            Email is not verified! Please check your Email
          </span>
        </div>
      )}

      <div className={user?.emailVerified ? "mt-6" : "mt-[25.5px] md:mt-5"}>
        <div className="mx-[16px] md:mx-[21px] mt-[-8px] md:mt-0">
          <Banner />

          <div className="mt-11 md:mt-[70px] mb-10 w-[100%] md:w-[100%] mx-auto rounded-lg px-0 md:flex flex-col md:flex-row justify-around items-center py-3 pt-0 py-sm-0">
            <div
              className="w-[96%] md:w-[43%] lg:w-[38%] rounded"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <Gallery />
            </div>

            <div
              className="text-start w-[95%] md:w-[45%] lg:w-[52%] mx-auto md:mx-0 mt-5"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <h2 className="text-[27.5px] md:text-[34px] mb-3 font-bold opacity-80 my-transition-4">
                Looking For Used Phone Resale Market?
              </h2>
              <p className="text-gray-600 text-[15px] md:text-[16px] leading-[27px] text-justify">
                <TypeAnimation
                  sequence={[
                    "Welcome to my Recycle Hut website. This is a fully functional, fully responsive, full stack (MERN) used phone buy and resale website. By creating a buyer account, you can see your favourite phones and buy used phones by making online payment process. You can also sell your favourite used phones by creating a seller account. So, Buy or Sell your used phones under these three category now!",
                    3000,
                  ]}
                  speed={75}
                  cursor={false}
                  repeat={Infinity}
                />
              </p>
            </div>
          </div>
          <WhyChooseUs />
          <Categories />
        </div>
      </div>
    </div>
  );
};

export default Home;
